// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].rules[0].oneOf[1].use[0]!../../../../node_modules/@angular-devkit/build-angular/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[5].rules[0].oneOf[1].use[1]!../../../assets/css/pages/inbox/inbox.css");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-modal .modal-content {
  /* max-width: 90% !important; */
  max-height: 90vh;
  font-size: 36px;
  padding: 20px;
  overflow-x: hidden;
  overflow-y: auto;
  margin-right: 0px !important ;
}

.childPage-modal .modal-content {
  /* max-width: 90% !important; */
  max-height: 90vh;
  font-size: 36px;
  padding: 20px;
  overflow-x: hidden;
  overflow-y: auto;
  margin-right: 0px !important ;
}
.dd {
  position: relative;
  display: block;
  margin: 0;
  padding: 0;
  max-width: 100%;
  list-style: none;
  font-size: 13px;
  line-height: 20px;
}
.dd-list {
  display: block;
  position: relative;
  margin: 0;
  padding: 0;
  list-style: none;
}
.dd-item,
.dd-empty,
.dd-placeholder {
  display: block;
  position: relative;
  margin: 0;
  padding: 0;
  min-height: 20px;
  font-size: 13px;
  line-height: 20px;
}
.dd3-handle {
  position: absolute;
  margin: 0;
  left: 0;
  top: 0;
  cursor: move;
  width: 30px;
  text-indent: 100%;
  white-space: nowrap;
  overflow: hidden;
  background: #fafafa;
  background: -moz-linear-gradient(top, #fafafa 0%, #eee 100%);
  /* background: linear-gradient(top, #fafafa 0%, #eee 100%); */
  border-right: none;
}
.dd-handle {
  display: block;
  height: 30px;
  margin: 5px 0;
  padding: 5px 10px;
  color: #333;
  text-decoration: none;
  font-weight: bold;
  border: 1px solid #ccc;
  background: #fafafa;
  background: -moz-linear-gradient(top, #fafafa 0%, #eee 100%);
  /* background: linear-gradient(top, #fafafa 0%, #eee 100%); */
  border-radius: 3px;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}
.dd3-content {
  display: block;
  /* height: 30px; */
  margin: 5px 0;
  /* padding: 5px 30px 5px 40px; */
  color: #333;
  text-decoration: none;
  font-weight: bold;
  border: 1px solid #e1e1e1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background: #fff;
  background: -moz-linear-gradient(top, #fafafa 0%, #eee 100%);
  /* background: linear-gradient(top, #fafafa 0%, #eee 100%); */
  border-radius: 30px;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}
/* .remove-menu-item {
  position: absolute;
  height: 0;
  width: 0;
  font-size: 18px;
  top: -5px;
  right: -14px;
  z-index: 4;
  text-align: center;
} */
/* .edit-menu-item {
  position: absolute;
  height: 0;
  width: 0;
  font-size: 18px;
  top: -5px;
  right: 15px;
  z-index: 4;
  text-align: center;
} */
/* .add-menu-item {
  position: absolute;
  text-align: left;
  top: -3px;
  left: 0px;
  height: 0;
  width: 0;
} */
.add-child-item {
  position: absolute;
  text-align: right;
  font-size: 21px;
  top: -5px;
  right: 89px;
  height: 0;
  width: 0;
}

.cancel-child-item {
  position: absolute;
  text-align: right;
  font-size: 21px;
  top: -5px;
  right: 59px;
  height: 0;
  width: 0;
}

.child-droped {
  display: block;
  background-color: rgb(198 234 250);
  text-align: center;
  height: 0;
  transition: height 0.1s linear;
  border: none;
}

.drag-target .child-droped {
  height: 2.4em;
  border: 2px dashed #faa74a;
  margin: 7px;
  border-radius: 5px;
  font-weight: 500;
  padding-top: 4px;
}

.drag-over {
  background: #bdbdbd !important;
}
.drag-hint {
  background: #ffffff !important;
  transition: all 0.2s linear;
}

.comp-drag-over {
  background: #bdbdbd !important;
}

.drag-target.comp-drag-over {
  background: #bdbdbd !important;
}

.drag-hint.drag-target {
  background: #bdbdbd !important;
  /* margin-bottom: 35px; */
}

/* .childs-drag-hint-line {
  border: none;
  position: relative;
  transition: all 0.2s linear;
}

.drag-target .childs-drag-hint-line {
  background: #fafafa;
  width: 90%;
  height: 35px;
} */

.text-info {
  color: #7e55b3 !important;
}

.category-item {
  cursor: pointer;
  position: relative;
  padding: 5px 15px;
  border-bottom: 1px solid #7e55b3;
}
.category-item:last-child {
  border-bottom: none;
}

.category-list {
  background: #dec5fe;
  border-radius: 5px;
}

.categories.active:after {
  content: "";
  position: absolute;
  top: 7px;
  right: -30px;
  width: 0;
  height: 0;
  border: 15px solid transparent;
  border-left: 15px solid #dec5fe;
}

.mt-30 {
  margin-top: 30px;
}

.text-gray {
  color: #a3a3a3 !important;
}

.dd3-content .kt-checkbox {
  margin: 14px 0 0 15px !important;
}

.sibling.child-droped{
  display: none;
  background-color: rgb(198 234 250);
  text-align: center;
  height: 0;
  transition: height 0.2s linear;
  border: none;
  margin: -1px;

}

.drag-target .sibling.child-droped{
  height: 2.4em;
  border-top: 0px;
  width: 100%;
  border-radius: 0px;
  background-color: #a6aeb282;
  margin-left: 0px;
  border: 2px dashed #faa74a;
  display: block;

}

`, "",{"version":3,"sources":["webpack://./src/app/views/menus/menus.component.css"],"names":[],"mappings":"AACA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA;;;EAGE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,MAAM;EACN,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EAEnB,4DAA4D;EAC5D,6DAA6D;EAC7D,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EAEnB,4DAA4D;EAC5D,6DAA6D;EAE7D,kBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,gCAAgC;EAChC,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAEhB,4DAA4D;EAC5D,6DAA6D;EAE7D,mBAAmB;EACnB,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;;;;;;;;;GASG;AACH;;;;;;;;;GASG;AACH;;;;;;;GAOG;AACH;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,SAAS;EACT,WAAW;EACX,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,SAAS;EACT,WAAW;EACX,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,kBAAkB;EAClB,SAAS;EACT,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;;;;;;;;;;GAUG;;AAEH;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,kBAAkB;EAClB,SAAS;EACT,8BAA8B;EAC9B,YAAY;EACZ,YAAY;;AAEd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;;AAEhB","sourcesContent":["@import \"../../../assets/css/pages/inbox/inbox.css\";\r\n.page-modal .modal-content {\r\n  /* max-width: 90% !important; */\r\n  max-height: 90vh;\r\n  font-size: 36px;\r\n  padding: 20px;\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n  margin-right: 0px !important ;\r\n}\r\n\r\n.childPage-modal .modal-content {\r\n  /* max-width: 90% !important; */\r\n  max-height: 90vh;\r\n  font-size: 36px;\r\n  padding: 20px;\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n  margin-right: 0px !important ;\r\n}\r\n.dd {\r\n  position: relative;\r\n  display: block;\r\n  margin: 0;\r\n  padding: 0;\r\n  max-width: 100%;\r\n  list-style: none;\r\n  font-size: 13px;\r\n  line-height: 20px;\r\n}\r\n.dd-list {\r\n  display: block;\r\n  position: relative;\r\n  margin: 0;\r\n  padding: 0;\r\n  list-style: none;\r\n}\r\n.dd-item,\r\n.dd-empty,\r\n.dd-placeholder {\r\n  display: block;\r\n  position: relative;\r\n  margin: 0;\r\n  padding: 0;\r\n  min-height: 20px;\r\n  font-size: 13px;\r\n  line-height: 20px;\r\n}\r\n.dd3-handle {\r\n  position: absolute;\r\n  margin: 0;\r\n  left: 0;\r\n  top: 0;\r\n  cursor: move;\r\n  width: 30px;\r\n  text-indent: 100%;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  background: #fafafa;\r\n  background: -webkit-linear-gradient(top, #fafafa 0%, #eee 100%);\r\n  background: -moz-linear-gradient(top, #fafafa 0%, #eee 100%);\r\n  /* background: linear-gradient(top, #fafafa 0%, #eee 100%); */\r\n  border-right: none;\r\n}\r\n.dd-handle {\r\n  display: block;\r\n  height: 30px;\r\n  margin: 5px 0;\r\n  padding: 5px 10px;\r\n  color: #333;\r\n  text-decoration: none;\r\n  font-weight: bold;\r\n  border: 1px solid #ccc;\r\n  background: #fafafa;\r\n  background: -webkit-linear-gradient(top, #fafafa 0%, #eee 100%);\r\n  background: -moz-linear-gradient(top, #fafafa 0%, #eee 100%);\r\n  /* background: linear-gradient(top, #fafafa 0%, #eee 100%); */\r\n  -webkit-border-radius: 3px;\r\n  border-radius: 3px;\r\n  box-sizing: border-box;\r\n  -moz-box-sizing: border-box;\r\n}\r\n.dd3-content {\r\n  display: block;\r\n  /* height: 30px; */\r\n  margin: 5px 0;\r\n  /* padding: 5px 30px 5px 40px; */\r\n  color: #333;\r\n  text-decoration: none;\r\n  font-weight: bold;\r\n  border: 1px solid #e1e1e1;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  background: #fff;\r\n  background: -webkit-linear-gradient(top, #fafafa 0%, #eee 100%);\r\n  background: -moz-linear-gradient(top, #fafafa 0%, #eee 100%);\r\n  /* background: linear-gradient(top, #fafafa 0%, #eee 100%); */\r\n  -webkit-border-radius: 3px;\r\n  border-radius: 30px;\r\n  box-sizing: border-box;\r\n  -moz-box-sizing: border-box;\r\n}\r\n/* .remove-menu-item {\r\n  position: absolute;\r\n  height: 0;\r\n  width: 0;\r\n  font-size: 18px;\r\n  top: -5px;\r\n  right: -14px;\r\n  z-index: 4;\r\n  text-align: center;\r\n} */\r\n/* .edit-menu-item {\r\n  position: absolute;\r\n  height: 0;\r\n  width: 0;\r\n  font-size: 18px;\r\n  top: -5px;\r\n  right: 15px;\r\n  z-index: 4;\r\n  text-align: center;\r\n} */\r\n/* .add-menu-item {\r\n  position: absolute;\r\n  text-align: left;\r\n  top: -3px;\r\n  left: 0px;\r\n  height: 0;\r\n  width: 0;\r\n} */\r\n.add-child-item {\r\n  position: absolute;\r\n  text-align: right;\r\n  font-size: 21px;\r\n  top: -5px;\r\n  right: 89px;\r\n  height: 0;\r\n  width: 0;\r\n}\r\n\r\n.cancel-child-item {\r\n  position: absolute;\r\n  text-align: right;\r\n  font-size: 21px;\r\n  top: -5px;\r\n  right: 59px;\r\n  height: 0;\r\n  width: 0;\r\n}\r\n\r\n.child-droped {\r\n  display: block;\r\n  background-color: rgb(198 234 250);\r\n  text-align: center;\r\n  height: 0;\r\n  transition: height 0.1s linear;\r\n  border: none;\r\n}\r\n\r\n.drag-target .child-droped {\r\n  height: 2.4em;\r\n  border: 2px dashed #faa74a;\r\n  margin: 7px;\r\n  border-radius: 5px;\r\n  font-weight: 500;\r\n  padding-top: 4px;\r\n}\r\n\r\n.drag-over {\r\n  background: #bdbdbd !important;\r\n}\r\n.drag-hint {\r\n  background: #ffffff !important;\r\n  transition: all 0.2s linear;\r\n}\r\n\r\n.comp-drag-over {\r\n  background: #bdbdbd !important;\r\n}\r\n\r\n.drag-target.comp-drag-over {\r\n  background: #bdbdbd !important;\r\n}\r\n\r\n.drag-hint.drag-target {\r\n  background: #bdbdbd !important;\r\n  /* margin-bottom: 35px; */\r\n}\r\n\r\n/* .childs-drag-hint-line {\r\n  border: none;\r\n  position: relative;\r\n  transition: all 0.2s linear;\r\n}\r\n\r\n.drag-target .childs-drag-hint-line {\r\n  background: #fafafa;\r\n  width: 90%;\r\n  height: 35px;\r\n} */\r\n\r\n.text-info {\r\n  color: #7e55b3 !important;\r\n}\r\n\r\n.category-item {\r\n  cursor: pointer;\r\n  position: relative;\r\n  padding: 5px 15px;\r\n  border-bottom: 1px solid #7e55b3;\r\n}\r\n.category-item:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.category-list {\r\n  background: #dec5fe;\r\n  border-radius: 5px;\r\n}\r\n\r\n.categories.active:after {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 7px;\r\n  right: -30px;\r\n  width: 0;\r\n  height: 0;\r\n  border: 15px solid transparent;\r\n  border-left: 15px solid #dec5fe;\r\n}\r\n\r\n.mt-30 {\r\n  margin-top: 30px;\r\n}\r\n\r\n.text-gray {\r\n  color: #a3a3a3 !important;\r\n}\r\n\r\n.dd3-content .kt-checkbox {\r\n  margin: 14px 0 0 15px !important;\r\n}\r\n\r\n.sibling.child-droped{\r\n  display: none;\r\n  background-color: rgb(198 234 250);\r\n  text-align: center;\r\n  height: 0;\r\n  transition: height 0.2s linear;\r\n  border: none;\r\n  margin: -1px;\r\n\r\n}\r\n\r\n.drag-target .sibling.child-droped{\r\n  height: 2.4em;\r\n  border-top: 0px;\r\n  width: 100%;\r\n  border-radius: 0px;\r\n  background-color: #a6aeb282;\r\n  margin-left: 0px;\r\n  border: 2px dashed #faa74a;\r\n  display: block;\r\n\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
